import { useContext } from 'react';
import { ConfirmContext } from './context';

export function usePrompt() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('usePrompt must be used inside <ConfirmProvider>');
  return ctx.prompt;
}
